<template>
  <div class="wrapper">
    <a-config-provider
      :theme="{
        algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
      }"
    >
      <ChatWindow />
    </a-config-provider>
  </div>
</template>
<script setup lang="ts">
import { theme } from 'ant-design-vue'
import ChatWindow from './components/chat/chat-window.vue'
import { useDark } from '@vueuse/core'
const isDark = useDark()
</script>
<style>
.wrapper {
  position: relative;
}
</style>
